<template>
  <div class="lotery-wrapper">
    <div class="lotery-wrapper__header">Losuj nagrody:</div>
      <div class="lotery-wrapper__points">Twoje punkty: {{ points }}</div>
      <div class="lotery-wrapper__draw-button"
        @click='random' v-if="rewards.length > 0">
        <div>Losuj</div>
      </div>
      <div class="lotery-wrapper__winer">
        Wylosowałeś: {{ winReward }}
      </div>
      <div class="lotery-wrapper__rewards">
        <div class="lotery-wrapper__rewards--header">Ustawienia nagród</div>
        <div v-for="(reward, index) in rewards" :key="index">
          {{ reward.name }}
          <button @click="removeReward(reward.firekey)">Usuń</button>
        </div>
      </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

const Chance = require('chance');

const chance = new Chance();

export default {
  data() {
    return {
      winReward: '',
    };
  },
  beforeMount() {
    this.getPoints();
    this.getAllRewards();
  },
  computed: {
    ...mapState({
      points: (state) => state.pointsStore.points,
      rewards: (state) => state.loteryStore.rewards,
    }),
  },
  methods: {
    ...mapActions({
      getPoints: 'pointsStore/getPoints',
      removePoints: 'pointsStore/removePoints',
      addReward: 'loteryStore/addReward',
      getAllRewards: 'loteryStore/getAllRewards',
      removeReward: 'loteryStore/removeReward',
    }),
    random() {
      if ((this.points - 5) < 0) return;
      const type = chance.weighted(this.rewards.map(
        (reward) => reward.name,
      ), this.rewards.map((reward) => reward.weighted.weighted));
      this.winReward = '';
      this.removePoints(5);
      setTimeout(() => {
        this.winReward = type;
      }, 1000);
    },
  },
};
</script>

<style scoped lang='scss'>
 .lotery-wrapper {
   &__header {
     font-size: 30px;
     font-weight: 700;
     padding: 15px;
  }
  &__points {
    font-weight: 600;
    padding: 15px;
  }
  &__draw-button {
    margin: 30px auto;
    height: 150px;
    width: 150px;
    border-radius: 100px;
    background: red;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $font-light-color;
    font-size: 20px;
    font-weight: 800;
  }
  &__winer {
    text-align: center;
    margin-bottom: 40px;
  }
  &__rewards {
    padding: 15px;

    &--header{
      font-size: 30px;
      text-align: center;
      font-weight: 700;
      margin-bottom: 15px;
    }
  }
 }
</style>
